import { render, staticRenderFns } from "./ExamineConsultant.vue?vue&type=template&id=af4d4cac&style=height%3A%20100%25%3B"
import script from "./ExamineConsultant.vue?vue&type=script&lang=js"
export * from "./ExamineConsultant.vue?vue&type=script&lang=js"
import style0 from "./ExamineConsultant.vue?vue&type=style&index=0&id=af4d4cac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports